import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ImageSlider = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true, 
        autoplaySpeed: 5000,
        fade: true
    };

    return (
        <Slider {...settings}>
            <div>
                <img src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/slider-images%2Fimage1.jpg?alt=media" className="slider-image" alt="main slider" title="#htmlcaption1" />
          </div>
          <div>
                <img src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/slider-images%2Fimage2.jpg?alt=media" className="slider-image" alt="main slider" title="#htmlcaption2" />
          </div>
          <div>
                <img src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/slider-images%2Fimage3.jpg?alt=media" className="slider-image" alt="main slider" title="#htmlcaption3" />
          </div>
           <div>
                <img src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/slider-images%2Fimage4.jpg?alt=media" className="slider-image" alt="main slider" title="#htmlcaption4" />
          </div>
           <div>
                <img src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/slider-images%2Fimage5.jpg?alt=media" className="slider-image" alt="main slider" title="#htmlcaption5" />
          </div>
           <div>
                <img src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/slider-images%2Fimage6.jpg?alt=media" className="slider-image" alt="main slider" title="#htmlcaption6" />
          </div>
           <div>
                <img src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/slider-images%2Fimage7.jpg?alt=media" className="slider-image" alt="main slider" title="#htmlcaption7" />
          </div>
        </Slider>
	);
}

export default ImageSlider;